import { envVars } from './environment.env-vars'

export const environment: any = {
    host: 'www.mistergreen.nl',
    basePath: '',
    production: true,
    locale: {
        countryCode: 'NL',
        languageCode: 'nl',
    },
    gateway: {
        v3: {
            graphql: 'https://api.mistergreen.io/graphql',
        },
    },
    ...envVars,
}
